'use client';

import React from 'react';
import { Agentic as SiteComponentsAgenticChat } from 'value-digital-site-components';
import { AgenticProps } from './common/types';
import { useFeatureFlag } from '@/store/contexts/featureFlagContext';
import { useGlobalContext } from '@/store/contexts/GlobalContext';
import { useAgenticConfig } from '@/hooks/useAgenticConfig';

/**
 * SiteComponentsAgentic - Thin wrapper for the Agentic component from value-digital-site-components.
 * Accepts the same AgenticProps interface as the legacy component for seamless toggling.
 *
 * This file can be deleted once the migration is complete and the legacy code is removed.
 */
const SiteComponentsAgentic = ({
  dispatch,
  deviceInfo,
  deviceType,
  pageName,
  allFilters,
  refreshCart,
  refreshOrderSummary,
  productsTitleRef,
}: AgenticProps) => {
  const { featureFlags } = useFeatureFlag();
  const { brand, agenticChat, appWebview } = useGlobalContext();

  const agenticConfig = useAgenticConfig({
    dispatch,
    featureFlags,
    brand,
    agenticChat,
    deviceInfo,
    deviceType,
    pageName,
    allFilters,
    refreshCart,
    refreshOrderSummary,
    productsTitleRef,
    appWebview,
  });

  return (
    <div className="agentic-sc">
      <SiteComponentsAgenticChat {...agenticConfig} />
    </div>
  );
};

export default SiteComponentsAgentic;
